export default "__VITE_ASSET__Djt1VrMb__"